import { render, staticRenderFns } from "./CmsIcmStandard.vue?vue&type=template&id=8f13bc50&scoped=true&"
import script from "./CmsIcmStandard.vue?vue&type=script&lang=js&"
export * from "./CmsIcmStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f13bc50",
  null
  
)

export default component.exports